export default __webpack_public_path__ + "static/media/collapse.7e684dd2.svg";